import React from 'react';

const AWS_User_Access = () => {
  return (
    <div>
      <h1>AWS_User_Access</h1>
      <p>This is the AWS_User_Access component.</p>
    </div>
  );
};

export default AWS_User_Access;
